var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w100 btn",attrs:{"id":"timer"}},[_c('div',{staticClass:"text-nowrap"},[_c('i',{staticClass:"fa fa-clock mr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.time)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }